import { render, staticRenderFns } from "./OverlayPromo.vue?vue&type=template&id=5cea7b67&scoped=true"
import script from "./OverlayPromo.vue?vue&type=script&lang=js"
export * from "./OverlayPromo.vue?vue&type=script&lang=js"
import style0 from "./OverlayPromo.vue?vue&type=style&index=0&id=5cea7b67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cea7b67",
  null
  
)

export default component.exports